import { Button, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface ActivateOnlinePaymentSectionProps {
  disabled?: boolean
  onReconnect: () => void
}

export const ActivateOnlinePaymentSection = ({
  disabled,
  onReconnect,
}: ActivateOnlinePaymentSectionProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex alignItems="flex-start" flexDirection="column" gap={Spacing.S8}>
      <Text variant="bodyLG" weight="medium">
        {t('settings.organization.card_payments.configuration.activate.title')}
      </Text>
      <Text colorVariant="secondary">
        {t('settings.organization.card_payments.configuration.activate.description')}
      </Text>
      <Text colorVariant="secondary" variant="bodySM">
        {t('settings.organization.card_payments.configuration.activate.note')}
      </Text>
      <Button disabled={disabled} icon="plug" onClick={onReconnect} variant="outlined">
        {t('settings.organization.card_payments.configuration.activate.button')}
      </Button>
    </Flex>
  )
}
